<!-- ORGANISM: DrawerSection.vue -->

<script setup lang="ts">
//
// Imports / Types
//
import DrawerItem from "../molecules/DrawerItem.vue";
import type { DrawerItemType } from "../../../../types/components/common/navigation-drawer";

//
// Props
//
defineProps<{
  title?: string;
  items: readonly DrawerItemType[];
}>();
</script>

<template>
  <v-list density="compact" nav>
    <!-- Section Title -->
    <v-list-subheader v-if="title" class="text-uppercase text-caption text-medium-emphasis">
      {{ title }}
    </v-list-subheader>

    <!-- Drawer Items -->
    <drawer-item v-for="item in items" :key="item.title" v-bind="item" />
  </v-list>
</template>
